import { PaginatedRequestParams } from "api";

export enum LoadingFilterFormField {
  MaterialName = 'MaterialName',
  NetWeight= 'NetWeight',
  LoadingBy = 'LoadingBy',
  LoadingDate='LoadingDate',
  Description="Description",
  MaterialType="MaterialType"
}

export type LoadingFilterFormValues = {
  [LoadingFilterFormField.MaterialName]: string | undefined;
  [LoadingFilterFormField.NetWeight]: string | undefined;
  [LoadingFilterFormField.LoadingDate]: string | undefined;
  [LoadingFilterFormField.LoadingBy]: string | undefined;
  [LoadingFilterFormField.Description]: string | undefined;
  [LoadingFilterFormField.MaterialType]: string | undefined;


};


export type MaterialDetailFilterFormValues = {
  [LoadingFilterFormField.MaterialName]: string | undefined;
  [LoadingFilterFormField.Description]: string | undefined;
  [LoadingFilterFormField.MaterialType]: string | undefined;
};

export type LoadingFilterFormValuesPaginated = LoadingFilterFormValues &
  PaginatedRequestParams;